<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card tab2-card">
                <div class="card-header">
                    <h5 class="text-capitalize">{{type}} Content-Creator</h5>
                    <label class="text-muted">All fields marked with <span class="text-danger">*</span> are required</label>
                </div>
                <div class="card-body tab2-card">
                    <form [formGroup]="creatorForm" class="needs-validation user-add">
                        <div class="form-group row">
                            <label for="validationCustom0" class="col-xl-3 col-md-4"><span>*</span>
                                First Name</label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control " formControlName="firstName" id="validationCustom0"
                                       type="text" placeholder="First Name" required>
                                <em class="error" *ngIf="!creatorForm.get('firstName').valid && (creatorForm.get('firstName').dirty || creatorForm.get('firstName').touched)">First name is required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom1" class="col-xl-3 col-md-4"><span>*</span>
                                Last Name</label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control " formControlName="lastName" id="validationCustom1"
                                       type="text" placeholder="Last Name" required>
                                <em class="error" *ngIf="!creatorForm.get('lastName').valid && (creatorForm.get('lastName').dirty || creatorForm.get('lastName').touched)">Last name is required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom3" class="col-xl-3 col-md-4"><span>*</span>
                                Contact Number</label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control " formControlName="mobile" id="validationCustom3"
                                       type="text" placeholder="Contact Number" (keypress)="numberPattern($event)" maxlength="15" minlength="10" required="">
                                <em class="error" *ngIf="!creatorForm.get('mobile').valid && (creatorForm.get('mobile').dirty || creatorForm.get('mobile').touched)">Contact Number is required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom2" class="col-xl-3 col-md-4"><span>*</span>
                                Email Address</label>
                            <div class="col-xl-8 col-md-7">
                                <input *ngIf="type == 'add' || email" class="form-control " formControlName="email_id" id="validationCustom2"
                                       type="email" placeholder="Email" required>
                                <input *ngIf="type == 'edit' && !email" readonly class="form-control " formControlName="email_id" id="validationCustom16"
                                       type="email" placeholder="Email" required>
                                <em class="error" *ngIf="creatorForm.get('email_id').hasError('required') && (creatorForm.get('email_id').dirty || creatorForm.get('email_id').touched)">Email is required</em>
                                <em class="error" *ngIf="creatorForm.get('email_id').hasError('pattern')">Invalid Email-Id</em>
                            </div>
                        </div>
<!--                        <div class="form-group row">-->
<!--                            <label class="col-xl-3 col-md-4"><span>*</span>-->
<!--                                Institution Name</label>-->
<!--                            <div class="col-xl-8 col-md-7">-->
<!--                                <input class="form-control" formControlName="schoolId" id="validationCustom21"-->
<!--                                       type="text" placeholder="Institution Name" required="" readonly>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="form-group row ">
                            <label class="col-xl-3 col-md-4"><span style="visibility: hidden">*</span>Date Of Joining</label>
                            <div class="col-xl-8 col-md-7 form-group">
                                <div class="input-group">
                                    <input class="form-control" name="mydate" placeholder="mm/dd/yyyy"
                                           formControlName="doj" angular-mydatepicker #dp="angular-mydatepicker" [options]="myDpOptions" (inputFieldChanged)="checkDoj($event)" (keypress)="datePattern($event)"
                                           (dateChanged)="onDateChanged($event)"/>
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-primary" (click)="dp.toggleCalendar()">
                                            <i class="fa fa-calendar-o"></i>
                                        </button>
                                    </div>
                                </div>
                                <em class="error" *ngIf="!creatorForm.get('doj').valid && (creatorForm.get('doj').dirty || creatorForm.get('doj').touched)">Enter Valid Date</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-xl-3 col-md-4" ><span style="visibility: hidden">*</span>
                                Date Of Birth</label>
                            <div class="col-xl-8 col-md-7 form-group">
                                <div class="input-group">
                                    <input class="form-control" name="mydate" placeholder="mm/dd/yyyy"
                                           formControlName="dob" angular-mydatepicker #db="angular-mydatepicker" [options]="myDpOptions1" (keypress)="datePattern($event)"
                                           (dateChanged)="onDateChanged($event)"/>
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-primary" (click)="db.toggleCalendar()">
                                            <i class="fa fa-calendar-o"></i>
                                        </button>
                                    </div>

                                </div>
                                <em class="error" *ngIf="!creatorForm.get('dob').valid && (creatorForm.get('dob').dirty || creatorForm.get('dob').touched)">Date of Birth is required</em>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="validationCustom7" class="col-xl-3 col-md-4"><span style="visibility: hidden">*</span>
                                Gender</label>
                            <div class="col-xl-8 col-md-7">
                                <select class="form-control"  formControlName="gender" id="validationCustom7">
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="n/a">Do not want to disclose</option>
                                </select>
                                <em class="error" *ngIf="!creatorForm.get('gender').valid && (creatorForm.get('gender').dirty || creatorForm.get('gender').touched)">Gender is required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom15" class="col-xl-3 col-md-4"><span style="visibility: hidden">*</span>
                                Designation</label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control" formControlName="designation" id="validationCustom15"
                                       type="text" placeholder="Designation">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom8" class="col-xl-3 col-md-4"><span style="visibility: hidden">*</span>
                                Address 1</label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control" formControlName="address1" id="validationCustom8"
                                       type="text" placeholder="Address1">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom9" class="col-xl-3 col-md-4"><span style="visibility: hidden">*</span>
                                Address 2</label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control" formControlName="address2" id="validationCustom9"
                                       type="text"placeholder="Address2">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom10" class="col-xl-3 col-md-4"><span style="visibility: hidden">*</span>
                                City</label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control" formControlName="city" id="validationCustom10"
                                       type="text" placeholder="City">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-xl-3 col-md-4"><span style="visibility: hidden">*</span>
                                State</label>
                            <div class="col-xl-8 col-md-7">
                                <ng-select [items]="stateListData"
                                           bindLabel="name"
                                           bindValue="state_id"
                                           formControlName="state"
                                           placeholder="Please Select"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-xl-3 col-md-4"><span style="visibility: hidden">*</span>
                                Country</label>
                            <div class="col-xl-8 col-md-7">
                                <ng-select [items]="countryListData"
                                           bindLabel="name"
                                           bindValue="country_id"
                                           formControlName="country"
                                           placeholder="Please Select"
                                           (change)="stateList($event.country_id)">
                                </ng-select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom13" class="col-xl-3 col-md-4"><span style="visibility: hidden">*</span>
                                Zip </label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control" formControlName="postalCode" id="validationCustom13"
                                       type="text" placeholder="Enter Zip" (keypress)="numberPattern($event)" minlength="3" maxlength="9">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-xl-3 col-md-4"><span>*</span>
                                Status</label>
                            <div class="col-xl-8 col-md-7">
                                <select class="form-control " formControlName="status">
                                    <option value="1">Active</option>
                                    <option value="2">Suspended</option>
<!--                                    <option *ngIf="type =='edit'" value="3">Disengaged</option>-->
                                    <option *ngIf="type =='edit'" value="4">Deleted</option>
                                </select>
                                <em class="error" *ngIf="!creatorForm.get('status').valid && (creatorForm.get('status').dirty || creatorForm.get('status').touched)">status is required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-xl-3 col-md-4 "><span style="visibility: hidden">*</span>Profile Photo</label>
                            <div class="col-xl-8 col-md-7">
                                <input #myInput type="file" class="custom-upload-input" (change)="encodeImageFileAsURL($event)" accept=".png, .jpeg, .jpg">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-xl-3 col-md-4"  style="position: relative;left: 25%">
                                <div class="files-list fit-image" *ngFor="let file of imagepath;let i= index">
                                    <img  *ngIf="imagepath != ''"  [src]="sanitizer.bypassSecurityTrustResourceUrl(webhost + '/' + file)" alt="">
                                    <i *ngIf="imagepath != ''" class="fa fa-times" style="position: relative; right: 26px; bottom: 85px; cursor: pointer;  background: #eeeeee;
       padding: 10px; border-radius: 45px;" title="close" (click)="deleteImg()" ></i>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="pull-right">
                        <button type="button" (click)="addContent(type)" class="btn btn-primary">{{type == 'add' ? 'Save' : 'Update'}}Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="row mt-4" *ngIf="!allowAdd">
        <div class="col-md-12">
            <button class="btn btn-outline-primary pull-right" (click)="backAction()"><i class="fa fa-long-arrow-left fa-1x" aria-hidden="true"></i> Back</button>
        </div>
    </div> -->
    <!-- <div class="row d-flex justify-content-center list-card mt-5" *ngIf="!allowAdd">
        <div class="col-8">
            <button class="nodataList">You Don't Have Permission to add Content-Creator for {{schoolName}}</button>
        </div>
    </div> -->
</div>
<!-- Container-fluid Ends-->
